import { Injectable, OnInit } from '@angular/core';
import { Cookie } from 'ng2-cookies';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { AuthenticationService } from '../../../auth';
import { Globals } from '../../../globals';
import { Observable } from 'rxjs';
import { ExportTypes } from '../../enum/ExportTypes';

@Injectable()
export class SearchService implements OnInit {

    exportTypes = ExportTypes;

    constructor(private http: HttpClient, private authService: AuthenticationService, private globals: Globals) { }

    ngOnInit() : void {
        this.authService.isTokenValid();
    }


    /**
     * Get parameters based on the type
     * @param entity the type of entity to search for
     */
    getParametersByType(entity) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/search/' + entity + '/parameters/';
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }

    search(entity, parameterList, pageNumber, pageSize) {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/search/' + entity + '/?page=' + pageNumber + '&pageSize=' + pageSize;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const body = new HttpParams()
            .set('parameterList', JSON.stringify(parameterList));

        return this.http.post(url, body, {headers: requestHeaders, responseType: 'json'});
    }

    /**
     * Get person by ssn
     * @param ssn social security number
     */
    getPersonBySsn(ssn, deleted, page, pageSize) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/person/search?ssn=' + ssn + '&deleted='+ deleted + '&page=' + page + '&pageSize='+ pageSize;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }

    /**
     * Search Employers matching the parameter and its type
     * @param parameter the search string
     * @param type the kind of search string i.e. "Name", Organisation ID"
     * @param pageNumber the page to be retrieved
     * @param pageSize the number of records to be retrieved in each page
     */
    getEmployerByOrgId(parameter, pageNumber, pageSize) {
        this.authService.isTokenValid();

        let key = 'organisationId';
        const url = this.authService.getResourceURL() + '/api/v1/employer/search?' + key + '=' + parameter + '&page=' + pageNumber + '&pageSize='+ pageSize;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }

    /**
     * Search SUA-Projects based on name
     * @param parameter the search string
     * @param pageNumber the page to be retrieved
     * @param pageSize the number of records to be retrieved in each page
     */
    getProjectByProjectName(parameter, pageNumber, pageSize) {
        this.authService.isTokenValid();

        let key = 'projectName';
        const url = this.authService.getResourceURL() + '/api/v1/project/search?' + key + '=' + parameter + '&page=' + pageNumber + '&pageSize='+ pageSize;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }

    /**
     * Export search results
     * @param searchParameterList Search parameters to retrieve the result
     * @param format Format to export
     * @param component Which component is doing the export
     * @param exportDepartmentName
     * @param exportOnlyValid boolean for filtering valid registercontrols or projects
     */
    exportSearchResult(searchParameterList, format, component, exportDepartmentName, exportOnlyValid, reportMultiFile) {
        this.authService.isTokenValid();
        if(exportDepartmentName == null){
            exportDepartmentName = null
        }
        let url = null;
        if(component === this.exportTypes.RK_PDF && format === 'pdf') {
            url = this.authService.getResourceURL() + '/api/v1/search/export/default-rk/'+format+'/new';
        } else if (component === this.exportTypes.SUA_PDF && format === 'pdf') {
            url = this.authService.getResourceURL() + '/api/v1/search/export/default-project/new';
        } else if (component === this.exportTypes.SUA_PDF_OLD && format === 'gammal pdf') {
            url = this.authService.getResourceURL() + '/api/v1/search/export/default-project/old';
        } else if (component === this.exportTypes.RK_PDF_OLD) {
            url = this.authService.getResourceURL() + '/api/v1/search/export/default-rk/pdf/old';
        } else if (component === this.exportTypes.REPORT_LIST_PDF && format === 'pdf') {
            url = this.authService.getResourceURL() + '/api/v1/search/export/default-rk/report';
        } else if (component === this.exportTypes.RK_XML && format === 'xml') {
            url = this.authService.getResourceURL() + '/api/v1/search/export/default-rk/xml';
        } else if (component === this.exportTypes.REPORT_LIST_XML && format === 'xml') {
            url = this.authService.getResourceURL() + '/api/v1/search/export/default-rk/cease/xml';
        } else if (component === this.exportTypes.SUA_XML && format === 'xml') {
            url = this.authService.getResourceURL() + '/api/v1/search/export/default-project/xml';
        }

        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const body = new HttpParams()
            .set('searchParameterList', JSON.stringify(searchParameterList))
            .set('exportDepartmentName', exportDepartmentName)
            .set('exportOnlyValid', exportOnlyValid)
            .set('reportMultiFile', reportMultiFile);

        return this.http.post(url, body, {headers: requestHeaders, responseType: 'json'});
    }

    /**
     * Retrieve a filestream from backend
     * @param uuid UUID of file to fetch
     * @param type Filetype
     */
    getPdfStream(uuid, type) {
        this.authService.isTokenValid();

        const url = this.authService.getResourceURL() + '/api/v1/search/getPDF?uuid=' + uuid + '&type=' + type;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'blob'})
    }
    
    getAllDepartments() {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/govdepartment/';
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());
  
          return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }

    getSearchSuggestions(paramID: string): Observable<any> {
        this.authService.isTokenValid();

        const url = `${this.authService.getResourceURL()}/api/v1/search/suggestions?paramID=${paramID}`;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());
        
        return this.http.get(url, {headers: requestHeaders, responseType: 'json' });
    }
}
